/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Global Scalar Types
//==============================================================

/**
 * The `Decimal` scalar type represents a decimal value
 */
export type globalScalarDecimal = number;

/**
 * The `Currency` scalar type represents a currency code
 */
export type globalScalarCurrency = string;

/**
 * The `DateTime` scalar type represents a date and time
 */
export type globalScalarDateTime = string;

//==============================================================
// END Global Scalar Types
//==============================================================

//==============================================================
// START Enums and Input Objects
//==============================================================

/**
 * type of service provided by the caregiver
 * will be adding more services as required
 */
export enum ServiceType {
  AU_PAIR = "AU_PAIR",
  CARE_GIGS = "CARE_GIGS",
  CHILD_CARE = "CHILD_CARE",
  GENERIC = "GENERIC",
  HOUSEKEEPING = "HOUSEKEEPING",
  PET_CARE = "PET_CARE",
  SENIOR_CARE = "SENIOR_CARE",
  SPECIAL_NEEDS = "SPECIAL_NEEDS",
  TUTORING = "TUTORING",
}

//==============================================================
// END Enums and Input Objects
//==============================================================
